import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-center gap-2"
};
import { reactive, computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'CompanyContextMismatchModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['reload'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const uiState = reactive({
      show: computed({
        get: () => props.show,
        set: value => emit('update:show', value)
      }),
      reloading: false
    });
    const reloadPage = () => {
      uiState.reloading = true;
      emit('reload');
      setTimeout(() => {
        window.location.reload();
      }, 300);
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: uiState.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => uiState.show = $event),
        persistent: "",
        "max-width": "500",
        "overlay-color": "rgba(0, 0, 0, 0.8)",
        "overlay-opacity": "0.8"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          class: "text-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "bg-orange-100 text-orange-800 pa-4"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_v_icon, {
              color: "orange-darken-1",
              size: "24"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-alert-circle", -1)]))]),
              _: 1
            }), _cache[2] || (_cache[2] = _createElementVNode("span", {
              class: "text-lg font-semibold"
            }, "Firm Mismatch Detected", -1))])]),
            _: 1
          }), _createVNode(_component_v_card_text, {
            class: "pa-6"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
              class: "space-y-4"
            }, [_createElementVNode("div", {
              class: "text-base font-medium text-gray-800"
            }, " It appears you may have switched firms in a different browser tab or window. To ensure data security, you can only be logged in to one firm at a time. Please reload this page or close this tab. ")], -1)]))]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: "justify-center pb-6"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              color: "primary",
              size: "large",
              variant: "elevated",
              "prepend-icon": "mdi-refresh",
              onClick: reloadPage,
              loading: uiState.reloading,
              "min-width": "160"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(uiState.reloading ? 'Reloading...' : 'Reload Page'), 1)]),
              _: 1
            }, 8, ["loading"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};